var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVimeo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1AB7EA",
    d: "M24 21.6a2.4 2.4 0 01-2.4 2.4H2.4A2.4 2.4 0 010 21.6V2.4A2.4 2.4 0 012.4 0h19.2A2.4 2.4 0 0124 2.4v19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M20.23 7.869c-.076 1.688-1.248 4-3.515 6.934-2.343 3.065-4.326 4.597-5.948 4.597-1.005 0-1.855-.933-2.55-2.8l-1.391-5.133c-.516-1.866-1.07-2.8-1.66-2.8-.13 0-.58.272-1.353.817l-.811-1.051a226.9 226.9 0 002.515-2.258C6.652 5.19 7.503 4.67 8.071 4.618c1.342-.13 2.168.793 2.478 2.768.334 2.13.567 3.456.697 3.975.386 1.768.812 2.652 1.277 2.65.36 0 .902-.573 1.625-1.72.723-1.146 1.11-2.019 1.16-2.618.103-.99-.284-1.485-1.16-1.486a3.21 3.21 0 00-1.276.284c.847-2.792 2.466-4.149 4.855-4.07 1.771.053 2.606 1.209 2.504 3.468z"
  }))));
}

export default SvgVimeo;